//
//
//
//
//
//
//
//
//

export default {
    props: ['applicant'],
    data: function data() {
        return {
            status: null
        };
    },
    created: function created() {
        var $el = this;
        Event.$on('confirm-archive-applicant', function (status) {
            $el.$children[0].$data.showSmallModal = true;
            $el.status = status;
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('edit-ledger-payment');
    },

    methods: {
        archiveApplicant: function archiveApplicant() {
            var _this = this;

            var sendData = {
                id: this.applicant.id,
                status: this.status
            };

            axios.post('/prototype/person/applicants/archive', sendData).then(function (response) {
                Event.$emit('close-full-modal');
                Event.$emit('updated-applicants-list');
                Event.$emit('updated-pending-applicants-list');
                _this.$snotify.success('The application has been successfully ' + (_this.status == 'active' ? 'Archive.' : 'UnArchive.'));
            });
        },

        closeModal: function closeModal() {
            Event.$emit('close-small-modal');
        }
    },
    computed: {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/applicants/ConfirmArchiveApplicant.vue
// module id = lN3Q
// module chunks = 0 1